import React from "react";
import styled, { keyframes } from "styled-components";

const rotate = keyframes`
    to { transform: rotate(360deg); }
`;

const Spinner = styled.span`
    display: inline-block;
    width: 0.65em;
    height: 0.65em;
    vertical-align: middle;
    border: 2px solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: ${rotate} 0.8s linear infinite;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

const RatePlaceholder = ({ isLoading }) => (
    <span role="status" aria-label={isLoading ? "Wird geladen" : "Nicht verfügbar"}>
        <span aria-hidden="true">{isLoading ? <Spinner /> : "—"}</span>
    </span>
);

export default RatePlaceholder;
